import React from 'react';
import StyledButtonBase from 'views/rebranded-module/tours-module/common/components/TourBookingWidget/components/TourPackageRadio/TourPackageRadio.styles';
import {
  RiCheckboxCircleFill,
  RiCircleLine,
  RiMotorbikeLine,
  RiCarLine,
} from 'react-icons/ri';
import { Box, useTheme } from '@mui/material';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import Typography500 from 'views/common/components/UI/Typography500';
import { TbUsers } from 'react-icons/tb';
import { BiBed } from 'react-icons/bi';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const TourPackageRadio = (props) => {
  const {
    index,
    id,
    active,
    pricePerPerson,
    adultsNumber,
    numberOfMoto,
    numberOfBed,
    onClick,
    packageName = null,
    showPriceOnly = false,
    content: propsContent,
    offRoadPackages = false,
    disabled = false,
    isMultiDayOffroad = false,
    minPersons = null,
    maxPersons = null,
  } = props;
  const theme = useTheme();
  const tourPackageContentFromUseContent = useContent(
    'TourBookingWidgetComponent',
  );
  const content = tourPackageContentFromUseContent || propsContent;

  const getPersonsText = () => {
    if (isMultiDayOffroad) {
      const isRange = minPersons !== maxPersons;
      const personsNumber = isRange
        ? `${minPersons}–${maxPersons}`
        : minPersons;
      const personsText = isRange || minPersons > 1
        ? content.pluralPersonsText
        : content.singularPersonText;
      return interpolateString(personsText, { number: personsNumber });
    }
    return interpolateString(
      adultsNumber > 1 ? content.pluralPersonsText : content.singularPersonText,
      { number: adultsNumber },
    );
  };

  const getVehiclesText = () => {
    if (isMultiDayOffroad || offRoadPackages) {
      return interpolateString(
        numberOfMoto > 1
          ? content.pluralVehiclesText
          : content.singularVehiclesText,
        { number: numberOfMoto },
      );
    }
    return interpolateString(
      numberOfMoto > 1 ? content.pluralBikesText : content.singularBikeText,
      { motor_number: numberOfMoto },
    );
  };

  const getRoomsText = () => interpolateString(
    numberOfBed > 1 ? content.prularRoomsText : content.singularRoomText,
    { bed_number: numberOfBed },
  );

  return (
    <StyledButtonBase
      disabled={disabled}
      active={active}
      data-testid={
        offRoadPackages || isMultiDayOffroad
          ? `tour-package-seater-${adultsNumber}`
          : `tour-package-${index + 1}`
      }
      onClick={() => {
        onClick(id);
      }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%">
        <Box display="flex" alignItems="center">
          {active ? (
            <RiCheckboxCircleFill size={18} fill={theme.palette.primary.main} />
          ) : (
            <RiCircleLine size={18} />
          )}
          <Typography500 pl={1} pt={0.25} className="TPRPackageName">
            <span
              dangerouslySetInnerHTML={{
                __html:
                  packageName
                  || interpolateString(content.package, { number: index + 1 }),
              }}
            />
            {isMultiDayOffroad && (
              <span className="TPRSeaterBadge">
                {interpolateString(content.offroadPackageText, {
                  seater_number: adultsNumber,
                })}
              </span>
            )}
          </Typography500>
        </Box>
        <Box>
          <Typography500
            variant="body2"
            color="text.secondary"
            dangerouslySetInnerHTML={{
              __html: showPriceOnly
                ? interpolateString(content.offroadPriceText, {
                  price: pricePerPerson,
                })
                : interpolateString(content.perPersonText, {
                  price: pricePerPerson,
                }),
            }}
          />
        </Box>
      </Box>
      <Box display="flex" justifyContent="start" pt={1.5}>
        <Box className="TPRChip">
          <TbUsers size={16} />
          <Typography500
            variant="body3"
            className="TPRChipText"
            pl={0.5}
            pt={0.25}>
            {getPersonsText()}
          </Typography500>
        </Box>
        {numberOfMoto > 0 && (
          <Box className="TPRChip">
            {offRoadPackages || isMultiDayOffroad ? (
              <RiCarLine size={16} />
            ) : (
              <RiMotorbikeLine size={16} />
            )}
            <Typography500
              variant="body3"
              className="TPRChipText"
              pl={0.5}
              pt={0.25}>
              {getVehiclesText()}
            </Typography500>
          </Box>
        )}
        {numberOfBed > 0 && (
          <Box className="TPRChip">
            <BiBed size={16} />

            <Typography500
              variant="body3"
              className="TPRChipText"
              pl={0.5}
              pt={0.25}>
              {getRoomsText()}
            </Typography500>
          </Box>
        )}
      </Box>
    </StyledButtonBase>
  );
};

export { TourPackageRadio };
